<div [hidden]="!active" class="tab-content">
    <ng-content></ng-content>
</div>
